export enum InstanceEnvironment {
    DEV = 'DEV',
    TEST = 'TEST',
    PREPROD = 'PREPROD',
    LIVE = 'LIVE'
}

export const instanceEnvironment = Object.values(InstanceEnvironment);